import { PAY_SYMBOL_BY_ADDRESS } from "@/contract/constants";
import { fromTokenWei, getTokenDecimals } from "@/contract/tokens";
import { getReadWeb3 } from "@/contract/index";
import { findChainProject } from "@/film/chainProjects";
import { COINS, fmtCoin } from "@/film/pricing";

export function createEmptyCoinAmounts() {
  return Object.fromEntries(COINS.map((c) => [c, 0]));
}

export function formatCoinAmountsLine(amountsByCoin) {
  return COINS.map((c) => `${fmtCoin(amountsByCoin[c] ?? 0, c)} ${c}`).join(" · ");
}

async function mergeTokenAmountViews(rows, target) {
  const web3 = getReadWeb3();
  const decCache = new Map();
  for (const row of rows || []) {
    const token = row.token || row[0];
    const amountWei = row.amount ?? row[1] ?? "0";
    if (!token) continue;
    const payKey = String(token).toLowerCase();
    const coin = PAY_SYMBOL_BY_ADDRESS[payKey];
    if (!coin || !COINS.includes(coin)) continue;
    let decimals = decCache.get(payKey);
    if (decimals === undefined) {
      decimals = await getTokenDecimals(token, web3);
      decCache.set(payKey, decimals);
    }
    target[coin] += Number(fromTokenWei(amountWei, decimals));
  }
}

/** 解析 getUserSubAndRewardData 返回值为 AAPLB / USDT / BNB 人类可读金额 */
export async function mapUserSubAndRewardData(raw) {
  const subscribed = createEmptyCoinAmounts();
  const rewarded = createEmptyCoinAmounts();
  let subscriptions;
  let rewards;
  if (Array.isArray(raw)) {
    [subscriptions, rewards] = raw;
  } else if (raw && typeof raw === "object") {
    subscriptions = raw.subscriptions ?? raw[0];
    rewards = raw.rewards ?? raw[1];
  }
  await mergeTokenAmountViews(subscriptions, subscribed);
  await mergeTokenAmountViews(rewards, rewarded);
  return { subscribed, rewarded };
}

function formatOrderDate(timestampSec) {
  const ms = Number(timestampSec) * 1000;
  if (!Number.isFinite(ms)) return "";
  return new Date(ms).toLocaleString("zh-CN");
}

export async function mapChainOrders(rawOrders, chainProjects) {
  const web3 = getReadWeb3();
  const decCache = new Map();
  const rows = [];

  for (const o of rawOrders || []) {
    const cardToken = o.cardToken || o[0];
    const payToken = o.payToken || o[1];
    const payAmount = o.payAmount || o[2];
    const cardAmount = o.cardAmount || o[3];
    const timestamp = o.timestamp || o[4];

    const project = findChainProject(chainProjects, cardToken);
    const payKey = payToken.toLowerCase();
    let decimals = decCache.get(payKey);
    if (decimals === undefined) {
      decimals = await getTokenDecimals(payToken, web3);
      decCache.set(payKey, decimals);
    }
    const coin = PAY_SYMBOL_BY_ADDRESS[payKey] || "?";
    const spent = Number(fromTokenWei(payAmount, decimals));

    rows.push({
      project: project ? project.name : cardToken,
      projectId: project ? project.id : cardToken.toLowerCase(),
      qty: Number(cardAmount),
      coin,
      spent,
      date: formatOrderDate(timestamp),
      cardToken,
      payToken,
    });
  }

  return rows;
}
